import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiGift, FiArrowDown } = FiIcons;

const VoucherPromo = ({ onRequestVoucher }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Ablaufdatum: 27.12.2025
    const expiryDate = new Date('2025-12-27T23:59:59');
    const now = new Date();
    
    if (now <= expiryDate) {
      setIsVisible(true);
    }
  }, []);

  const handleClick = () => {
    // Nachricht setzen
    if (onRequestVoucher) {
      onRequestVoucher();
    }
    // Scrollen
    const element = document.querySelector('#contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  if (!isVisible) return null;

  return (
    <section className="pt-24 pb-8 px-4 sm:px-6 lg:px-8 bg-gradient-to-r from-amber-50 via-white to-amber-50 border-b border-amber-100">
      <div className="max-w-4xl mx-auto">
        <motion.div 
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="bg-white rounded-2xl shadow-xl overflow-hidden border border-amber-200"
        >
          <div className="grid md:grid-cols-2 gap-0">
            {/* Image Section */}
            <div className="relative h-64 md:h-auto bg-stone-100">
              <img 
                src="https://raw.githubusercontent.com/mike3011/Bilder/refs/heads/main/Gutschein%20Weihnachten.jpg" 
                alt="Gutschein für Yin Yoga und Klangschalen" 
                className="w-full h-full object-cover"
              />
              <div className="absolute top-4 left-4 bg-white/90 backdrop-blur-sm px-3 py-1 rounded-full text-xs font-semibold text-amber-800 uppercase tracking-wider shadow-sm">
                Weihnachts-Special
              </div>
            </div>

            {/* Content Section */}
            <div className="p-8 flex flex-col justify-center text-center md:text-left">
              <div className="flex items-center justify-center md:justify-start mb-4" style={{ color: '#314C40' }}>
                <SafeIcon icon={FiGift} className="w-6 h-6 mr-2" />
                <span className="font-serif italic text-lg">Geschenkidee</span>
              </div>
              
              <h3 className="text-2xl md:text-3xl font-serif text-stone-800 mb-4" style={{ fontFamily: 'Libre Baskerville, serif' }}>
                Zeit schenken. <br/>Ruhe schenken.
              </h3>
              
              <p className="text-stone-600 mb-8 leading-relaxed" style={{ fontFamily: 'Lato, sans-serif' }}>
                Verschenke Momente der tiefen Entspannung – Yin Yoga & Klangschalen als liebevolles Geschenk für dich und deine Liebsten.
              </p>
              
              <motion.button
                onClick={handleClick}
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
                className="w-full md:w-auto px-8 py-3 rounded-xl font-semibold text-white shadow-md flex items-center justify-center space-x-2 transition-colors"
                style={{ backgroundColor: '#314C40' }}
                onMouseEnter={(e) => e.target.style.backgroundColor = '#3E5E51'}
                onMouseLeave={(e) => e.target.style.backgroundColor = '#314C40'}
              >
                <span>Jetzt als Geschenk sichern</span>
                <SafeIcon icon={FiArrowDown} className="w-4 h-4" />
              </motion.button>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default VoucherPromo;